module.exports = __webpack_public_path__ + "static/media/milkfish.711a4211.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/milkfish.png
// module id = 323
// module chunks = 0